import { FC } from 'react';
import EnterpriseNoFixUnitPrice from '../../Detail/SupplierInfo/BasicInfo/EnterpriseNoFixUnitPrice';
import ContactInfo from '../../Detail/SupplierInfo/ContactInfo';
import RelatedPartyDeclaration from '../../Detail/SupplierInfo/RelatedPartyDeclaration';
import BankInfo from '../../Detail/SupplierInfo/BankInfo';
import React from 'react';
import BusinessInformation from '../../Detail/SupplierInfo/BusinessInformation';
import AssociatedEnterpriseInfo from '../../Detail/SupplierInfo/AssociatedEnterpriseInfo';
import FinancialInfo from '../../Detail/SupplierInfo/FinancialInfo';
import OrganizationInfo from '../../Detail/SupplierInfo/OrganizationInfo';
import { IndustryExperience } from '../../Detail/SupplierInfo/IndustryExperience';
import CollaborationCasesInfo from '../../Detail/SupplierInfo/CompetencyAssessment';

export const SupplierBasicDetail: FC<{
  isOverseas?: boolean; // 是否为海外供应商/个人
  hasCompletedWholeModification?: boolean;
  formDetail?: any;
  isCompany?: boolean;
  vendorId: string;
}> = (props) => {
  const {
    formDetail,
    isOverseas,
    hasCompletedWholeModification,
    isCompany,
    vendorId,
  } = props;
  return (
    <div>
      {/* 基础信息 */}
      <EnterpriseNoFixUnitPrice
        isExternal={true}
        formDetail={formDetail}
        isOverseas={isOverseas}
        isCompany={isCompany}
      />
      {/* 财务状况 */}
      {hasCompletedWholeModification && (
        <FinancialInfo formDetail={formDetail} />
      )}
      {/* 人员&架构 */}
      {!isOverseas && hasCompletedWholeModification && (
        <OrganizationInfo formDetail={formDetail} isExternal={true} />
      )}
      {/* 关联企业信息 */}
      <AssociatedEnterpriseInfo formDetail={formDetail} />
      {/* 关联关系申报 */}
      <RelatedPartyDeclaration formDetail={formDetail} />
      {/* 行业经验 */}
      {!isOverseas && hasCompletedWholeModification && (
        <IndustryExperience
          formDetail={formDetail}
          mode="card"
          vendorId={vendorId}
          isExternal
        />
      )}
      {/* 经营信息 */}
      <BusinessInformation isExternal />
      {/* 银行信息 */}
      <BankInfo formDetail={formDetail} />
      {/* 联系人信息 */}
      <ContactInfo formDetail={formDetail} />
      {/* 能力评估 */}
      {hasCompletedWholeModification && (
        <CollaborationCasesInfo formDetail={formDetail} vendorId={vendorId} />
      )}
    </div>
  );
};

export default SupplierBasicDetail;
